import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import RoleList from "../components/role/role";
import AddEditRole from "../components/role/addEditRole";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const RoleStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"RoleList"}
            screenOptions={{ headerShown: false }}>
            <AppStack.Screen name="RoleList" component={RoleList} />
            <AppStack.Screen name="AddRole" component={AddEditRole} />
        </AppStack.Navigator>
    );
};

export default RoleStack;